import React, { Component } from 'react'
import { connect } from 'react-redux'
import { changeSpeaker } from '../../../action/roomControlAction'
import {withTranslation} from "react-i18next";
import { CMSPath } from '../../../config/constant'

class SelectSpeaker extends Component {

    componentDidMount() {
        if (this.props.speakerList.length === 1) {
            this.props.changeSpeaker(this.props.speakerList[0]);
        }
    }

    speakerClick = (speaker) => {
        this.props.changeSpeaker(speaker);
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">

                <div class="widget-header widget-header-checkin">
                    { this.props.currentWidget.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{this.props.currentWidget.displayName}</div>
                </div>

                    <div class="widgets">
                        <div class="row">
                            <div class="col">
                                <p class="heading" style = {{color: this.props.menuColor.assetFontSelectorColor}}>{t('room_control.speaker_control.play_audio')}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2 menu-items">
                                {
                                    this.props.speakerList.length > 0 ?
                                        this.props.speakerList.map((iterator, index) => {
                                            return (
                                                <a onClick={() => this.speakerClick(iterator)}
                                                    className={
                                                        true ? "tile-sm thumbnails tile-container"
                                                            : "tile-sm thumbnails tile-container selected"
                                                    }>
                                                    <div class="thumb-img">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.37 108.32"><title>ico_speaker</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M14.92,34.64H8.63A8.63,8.63,0,0,0,0,43.27V65.06a8.62,8.62,0,0,0,8.63,8.62h6.29Z" /><path class="cls-1" d="M64.57,54.16V6.49s.56-4.89-3.19-6.2S55,2.54,55,2.54L24.78,34.64v39L55,105.78s2.63,3.57,6.38,2.25,3.19-6.19,3.19-6.19Z" /><path class="cls-1" d="M92.13,54.16s.33-12.32-8.83-21.07l-8.19,8.19s5.51,4.21,5.51,12.88-5.51,12.89-5.51,12.89l8.19,8.19C92.46,66.48,92.13,54.16,92.13,54.16Z" /><path class="cls-1" d="M91.08,82.85l8.43,8c16-15.65,14.91-36.64,14.91-36.64s1.14-21-14.91-36.63l-8.43,7.94a41.47,41.47,0,0,1,11.83,28.69A41.47,41.47,0,0,1,91.08,82.85Z" /><path class="cls-1" d="M125.77,54.16c0,27.24-18.24,44.42-18.24,44.42l8.43,8c22.62-23,21.4-52.44,21.4-52.44S138.58,24.74,116,1.72l-8.43,8S125.77,26.93,125.77,54.16Z" /></g></g></svg>
                                                    </div>
                                                    <div class="thumb-text align-center">
                                                        <p class="thumb-heading">{iterator.name ? iterator.name : `speaker ${index}`}</p>
                                                    </div>
                                                </a>
                                            )
                                        }) : null
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store2.roomControl.currentPage,
        guestDetail: state.store.home.guestDetails,
        selectedSpeaker: state.store.roomControl.selectedSpeaker,
        currentWidget: state.store.sideNavBar.currentWidget,
        speakerList: state.store.roomControl.speakerList,
        menuColor: state.store.home.MenuColor,
    }
}
export default connect(
    mapStateToProps,
    {
        // setRegPage,
        // VDAStatusApi,
        // currentWidget,
        // setLoadingMass,
        // popupOpenClose,
        // getSpeakerStatus
        changeSpeaker
    }
)(withTranslation('translations')(SelectSpeaker));